import { render, staticRenderFns } from "./NotifyModal.vue?vue&type=template&id=658e5b39&"
import script from "./NotifyModal.vue?vue&type=script&lang=ts&"
export * from "./NotifyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports